export const formattingSlashItems = [
  {
    title: 'Paragraph',
    description: 'Plain text paragraph',
    icon: '¶',
    group: 'Formatting',
    keywords: ['paragraph', 'text', 'plain', 'normal'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setParagraph().run();
    },
  },
  {
    title: 'Heading',
    description: 'Large section heading',
    icon: 'H1',
    group: 'Formatting',
    keywords: ['heading', 'h1', 'title', 'large'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleHeading({ level: 1 }).run();
    },
  },
  {
    title: 'Subheading',
    description: 'Medium section heading',
    icon: 'H2',
    group: 'Formatting',
    keywords: ['subheading', 'h2', 'subtitle', 'medium'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleHeading({ level: 2 }).run();
    },
  },
  {
    title: 'Blockquote',
    description: 'Indented quote block',
    icon: '"',
    group: 'Formatting',
    keywords: ['blockquote', 'quote', 'indent'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleBlockquote().run();
    },
  },
  {
    title: 'Code',
    description: 'Inline code',
    icon: '</>',
    group: 'Formatting',
    keywords: ['code', 'inline', 'monospace', 'backtick'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleCode().run();
    },
  },
  {
    title: 'Bullet List',
    description: 'Unordered list with bullet points',
    icon: '•',
    group: 'Formatting',
    keywords: ['bullet', 'list', 'unordered', 'ul'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleBulletList().run();
    },
  },
  {
    title: 'Ordered List',
    description: 'Numbered list',
    icon: '1.',
    group: 'Formatting',
    keywords: ['ordered', 'list', 'numbered', 'ol', 'number'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleOrderedList().run();
    },
  },
];
